export const navigationData = [
  {
    id: 1,
    name: 'Inicio',
    toScroll: 'IndexSection',
    offset: -120,
    duration: 500
  },
  {
    id: 2,
    name: 'Mis propiedades',
    toScroll: 'PropertiesSectionScroll',
    offset: -120,
    duration: 500
  }, 
  {
    id: 3,
    name: 'Sobre mi',
    toScroll: 'AboutSectionScroll',
    offset: -120,
    duration: 500
  },
  {
    id: 4,
    name: 'Contacto',
    toScroll: 'AboutSectionScroll',
    offset: -120,
    duration: 500
  },
  {
    id: 5,
    name: 'Mi cuenta',
    toScroll: 'https://unne.prop360.cl/',
    offset: -120,
    duration: 500
  },

];
